import { createAsyncThunk } from '@reduxjs/toolkit';
import { getEmployeeConfigurationsInBusiness } from 'store/projectUsers/services/getEmployeeConfigurationsInBusiness.service';

export const loadBusinessConfigurationsOfUser = createAsyncThunk(
  'users/loadBusinessConfigurationsOfUser',
  async (params) => {
    const { businessIds, userId } = params;
    const businessConfigurationPromises = [];
    // console.log('userId:', userId)

    businessIds.forEach((businessId) => {
      businessConfigurationPromises.push(
        getEmployeeConfigurationsInBusiness(businessId)
      );
    });

    const businessConfigurations = await Promise.all(businessConfigurationPromises);

    const filtered = businessConfigurations.map((configs) =>
      (configs || []).filter((c) => c?.userId === userId)
    );
    // console.log('filtered:', filtered)

    return filtered;
  }
);